import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ActivateTrialLicenseModel } from '../activate-trial-license.model';
import { ActivateTrialLicenseActions, ActivateTrialLicenseActionTypes } from '../actions/activate-trial-license.actions';

export interface State extends EntityState<ActivateTrialLicenseModel> {
  isLoaded: boolean;
  isLoading: boolean;
}

export const adapter: EntityAdapter<ActivateTrialLicenseModel> = createEntityAdapter<ActivateTrialLicenseModel>();

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isLoading: false
});

export function reducer(
  state = initialState,
  action: ActivateTrialLicenseActions
): State {
  switch (action.type) {
    case ActivateTrialLicenseActionTypes.LoadActivateTrialLicenses: {
      return state;
    }

    case ActivateTrialLicenseActionTypes.ClearActivateTrialLicenses: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
